import { ModalKey } from '@finn/ua-modals';

import { useProductPreference } from '~/hooks';

import { FeedbackDialog } from '../FeedbackDialog/FeedbackDialog';

const PRODUCT_PREFERENCE_CONFIG = {
  modalKey: ModalKey.PRODUCT_PREFERENCE_MODAL,
  translationPrefix: 'general.productPreferenceModal',
  trackingName: 'Retention Preference Modal',
  trackingLocation: 'PLP',
};

const prepareProductPreferenceData = (comment: string, session: any) => {
  const contactId = session?.user?.hs_contact_id;

  if (!contactId) {
    console.error('No contact ID found in session');

    return null;
  }

  return {
    contact_id: contactId,
    preference: comment,
  };
};

export function ProductPreferenceDialog() {
  return (
    <FeedbackDialog
      config={PRODUCT_PREFERENCE_CONFIG}
      useSubmissionHook={useProductPreference}
      prepareSubmissionData={prepareProductPreferenceData}
    />
  );
}
